import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import Box from '../styled/Box'
import Button from '../styled/Button'
import Card from '../styled/Card'

function BlogBlurb(props = {}) {
  const { post } = props
  const url = `/blog/${post.fields.slug}`
  return (
    <Card p={{ md: 'xl' }}>
      <Box as="p" fontStyle="italic" mb={{ _: 's', md: 'base' }}>
        On {post.frontmatter.date}, I wrote...
      </Box>
      <Box as="h2">
        <Box as={Link} to={url}>
          {post.frontmatter.title}
        </Box>
      </Box>
      <Box as="p" mb="l" mr={{ lg: 'xl' }}>
        {post.excerpt}
      </Box>
      <Button as={Link} to={url}>
        Keep reading
      </Button>
    </Card>
  )
}

BlogBlurb.propTypes = {
  post: PropTypes.object,
}

export default BlogBlurb
